import http from '@/utils/http-common'
import qs from 'qs'

const BASE = '/work-management'

function unwrap(response) {
  return response && response.data ? response.data : response
}

export function fetchWorkTemplates(params = {}) {
  return http.get(`${BASE}/work-templates`, { params }).then(unwrap)
}

export function fetchWorkTemplate(templateId) {
  return http.get(`${BASE}/work-templates/${templateId}`).then(unwrap)
}

export function createWorkTemplate(payload) {
  return http.post(`${BASE}/work-templates`, payload).then(unwrap)
}

export function updateWorkTemplate(templateId, payload) {
  return http.patch(`${BASE}/work-templates/${templateId}`, payload).then(unwrap)
}

export function saveWorkTemplateItems(templateId, payload) {
  return http.put(`${BASE}/work-templates/${templateId}/items`, payload).then(unwrap)
}

export function saveWorkTemplateFlow(templateId, payload) {
  return http.put(`${BASE}/work-templates/${templateId}/flow`, payload).then(unwrap)
}

export function publishWorkTemplate(templateId, payload) {
  return http.post(`${BASE}/work-templates/${templateId}/publish`, payload).then(unwrap)
}

export function cloneWorkTemplate(templateId, payload) {
  return http.post(`${BASE}/work-templates/${templateId}/clone`, payload).then(unwrap)
}

export function fetchTemplatePermissions(templateId) {
  return http.get(`${BASE}/work-templates/${templateId}/permissions`).then(unwrap)
}

export function updateTemplatePermissions(templateId, payload) {
  return http.put(`${BASE}/work-templates/${templateId}/permissions`, payload).then(unwrap)
}

export function fetchTemplateRevisions(templateId, params = {}) {
  return http.get(`${BASE}/work-templates/${templateId}/revisions`, { params }).then(unwrap)
}

export function fetchTemplateRevisionDetail(revisionId) {
  return http.get(`${BASE}/work-template-revisions/${revisionId}`).then(unwrap)
}

export function fetchProjectAssigneeCandidates(projectId) {
  return http.get(`${BASE}/projects/${projectId}/assignee-candidates`).then(unwrap)
}

export function fetchWorks(params = {}) {
  return http.get(`${BASE}/works`, { params }).then(unwrap)
}

export function fetchWorkDetail(workId) {
  return http.get(`${BASE}/works/${workId}`).then(unwrap)
}

export function fetchWorkFlow(workId) {
  return http.get(`${BASE}/works/${workId}/flow`).then(unwrap)
}

export function updateWorkTree(workId, payload) {
  return http.patch(`${BASE}/works/${workId}/tree`, payload).then(unwrap)
}

export function updateWorkExtraFields(workId, payload) {
  return http.patch(`${BASE}/works/${workId}/extra-fields`, payload).then(unwrap)
}

export function fetchWorkEvents(workId, params = {}) {
  return http.get(`${BASE}/works/${workId}/events`, { params }).then(unwrap)
}

export function fetchWorkRevisions(workId, params = {}) {
  return http.get(`${BASE}/works/${workId}/revisions`, { params }).then(unwrap)
}

export function fetchWorkRevisionDetail(revisionId) {
  return http.get(`${BASE}/work-revisions/${revisionId}`).then(unwrap)
}

export function fetchWorkOutputs(workId, params = {}) {
  return http.get(`${BASE}/works/${workId}/outputs`, { params }).then(unwrap)
}

export function fetchWorkRuns(workId, params = {}) {
  return http.get(`${BASE}/works/${workId}/runs`, { params }).then(unwrap)
}

export function fetchFilePreviewData(fileId, limit = 50, db = 'multiTableData') {
  return http.post(
    'annotation/get-filtered-item/',
    { id: fileId, db },
    {
      params: { limit },
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    }
  ).then(unwrap)
}

export function runWorkFormTextEngine(payload) {
  return http.post('annotation/text-engine/', payload).then(unwrap)
}

export function addWorkFormSourceRow(payload) {
  return http.post('annotation/add-row-for-form/', payload).then(unwrap)
}

export function fetchMyWorkItems(params = {}) {
  return http.get(`${BASE}/my/work-items`, { params }).then(unwrap)
}

export function fetchWorkItem(workItemId) {
  return http.get(`${BASE}/work-items/${workItemId}`).then(unwrap)
}

export function updateWorkItemStatus(workItemId, payload) {
  return http.patch(`${BASE}/work-items/${workItemId}/status`, payload).then(unwrap)
}

export function updateWorkItemAssignees(workItemId, payload) {
  return http.put(`${BASE}/work-items/${workItemId}/assignees`, payload).then(unwrap)
}

export function createWorkItemInput(workItemId, payload) {
  return http.post(`${BASE}/work-items/${workItemId}/inputs`, payload).then(unwrap)
}

export function createWorkItemManualInput(workItemId, payload) {
  return http.post(`${BASE}/work-items/${workItemId}/manual-inputs`, payload).then(unwrap)
}

export function updateWorkItemExtraFields(workItemId, payload) {
  return http.patch(`${BASE}/work-items/${workItemId}/extra-fields`, payload).then(unwrap)
}

export function rejectWorkItem(workItemId, payload) {
  return http.post(`${BASE}/work-items/${workItemId}/reject`, payload).then(unwrap)
}

export function createWorkItemComment(workItemId, payload) {
  return http.post(`${BASE}/work-items/${workItemId}/comments`, payload).then(unwrap)
}

export function runWorkItemRpa(workItemId, payload) {
  return http.post(`${BASE}/work-items/${workItemId}/runs`, payload).then(unwrap)
}

export function reviewWorkRun(runId, payload) {
  return http.post(`${BASE}/work-runs/${runId}/review`, payload).then(unwrap)
}

export function setOfficialWorkRun(runId, payload) {
  return http.post(`${BASE}/work-runs/${runId}/set-official`, payload).then(unwrap)
}

export function rollbackWorkRun(runId, payload) {
  return http.post(`${BASE}/work-runs/${runId}/rollback`, payload).then(unwrap)
}

export function fetchWorkRun(runId) {
  return http.get(`${BASE}/work-runs/${runId}`).then(unwrap)
}

export function fetchWorkRunInputSnapshots(runId) {
  return http.get(`${BASE}/work-runs/${runId}/input-snapshots`).then(unwrap)
}

export function fetchWorkOutput(outputId) {
  return http.get(`${BASE}/work-outputs/${outputId}`).then(unwrap)
}

export function setOfficialWorkOutput(outputId, payload) {
  return http.post(`${BASE}/work-outputs/${outputId}/set-official`, payload).then(unwrap)
}

export function rollbackWorkOutput(outputId, payload) {
  return http.post(`${BASE}/work-outputs/${outputId}/rollback`, payload).then(unwrap)
}

export function fetchNotifications(params = {}) {
  return http.get(`${BASE}/notifications`, { params }).then(unwrap)
}

export function markNotificationRead(notificationId) {
  return http.post(`${BASE}/notifications/${notificationId}/read`).then(unwrap)
}

export function markAllNotificationsRead(projectId) {
  return http.post(`${BASE}/notifications/read-all`, { project_id: projectId }).then(unwrap)
}

export function fetchUnreadNotificationCount(params = {}) {
  return http.get(`${BASE}/notifications/unread-count`, { params }).then(unwrap)
}

export function fetchNotificationDigest(params = {}) {
  return http.get(`${BASE}/notifications/digest`, { params }).then(unwrap)
}

export function receiveExternalWorkItemEvent(externalKey, payload) {
  return http.post(`${BASE}/external/work-items/${externalKey}/events`, payload).then(unwrap)
}

export function fetchExternalEvents(params = {}) {
  return http.get(`${BASE}/external/events`, { params }).then(unwrap)
}

export function fetchExternalEventDetail(eventId, params = {}) {
  return http.get(`${BASE}/external/events/${eventId}`, { params }).then(unwrap)
}

export function fetchRpaItem(rpaItemId) {
  return http.get(`/annotation/rpa-item/${rpaItemId}/`).then(unwrap)
}

export function fetchRpaItems(projectPk, params = {}) {
  return http.get(`/annotation/get-rpa-list/${projectPk}/`, { params }).then(unwrap)
}
